import { useEffect, useState, useCallback } from 'react'
import debounce from "lodash.debounce"
import { consumirApi } from '../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../utils/empresaUsuario'
import ErrorAlert from '../../components/common/ErrorAlert'
import Button from '../../components/common/Button'
import Modal from '../../components/modals/Modal'
import ModalConfirmacion from '../../components/modals/ModalConfirmacion'
import DesplegableDinamico from '../../components/modals/DesplegableDinamico'
import Form from '../../components/forms/Form'
import Input from '../../components/common/Input'
import Notification from '../../components/common/Notification'
import Spinner from '../../components/common/Spinner'
import ListaExpandible from '../../components/tables/ListaExpandible'

const Paquetes = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    //campos
    const [idPaquete, setIdPaquete] = useState("") // ID del paquete / dentro de registro de seccion para una paquete
    const [idSeccion, setIdSeccion] = useState("") // ID de la seccion / dentro de registro de seccion para una pauqete
    const [idPaqueteDetalle, setIdPaqueteDetalle] = useState("") // ID del detalle del paquete / caputrado para la funcion eliminar seccion
    const [secciones, setSecciones] = useState([]) // seccionesdisponibles/ en registro de seccion dentro de una paquete
    const [paquete, setPaquete] = useState("") // Nombre del paquete
    const [buscarPaquete, setBuscarPaquete] = useState("") // Campo para buscar por paquete
    const [seccion, setSeccion] = useState("") // Seccion seleccionada
    const [descripcion, setDescripcion] = useState("") // Descripción de la sección
    // tipo proyecto 
    const [tiposProyectoDatos, setTiposProyectoDatos] = useState([])
    const [idTipoProyecto, setIdTipoProyecto] = useState("")
    // modales
    const [mostrarModal, setMostrarModal] = useState(false) // Modal para registrar nueva paquete
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false) // Modal para eliminar un paquete
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false) // Modal para eliminar una paquete
    const [mostrarModalSeccion, setMostrarModalSeccion] = useState(false) // Modal para registrar nueva seccion
    const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = useState(false) // Modal de confirmación de eliminación
    // notificaciones y cargas
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [selectedId, setSelectedId] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    //carga inicial de paquetes
    useEffect(() => { obtenerPaquetes() }, [])

    // Consulta todas las Paquetes disponibles
    const obtenerPaquetes = async () => {
        const respuesta = await consumirApi('GET', `maestros/paquete/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : [])
        setCargando(false)
    }

    // Crear la función debounced utilizando useCallback
    const realizarConsultaDebounced = useCallback(
        debounce(async (paquete) => {
            if (paquete.trim() === "") {
                obtenerPaquetes()
            } else {
                // Reemplazar el / con un +
                const paqueteBusqueda = paquete.trim().replace(/\//g, '+')
                const respuesta = await consumirApi('GET', `maestros/paquete/buscar/${idEmpresa}/${paqueteBusqueda}`)
                setDatos(respuesta.success ? respuesta.data : respuesta.error)
            }
        }, 300), [] // Solo se crea una vez
    )

    // Consulta de paquetes de acuerdo a lo ingresado a campo busqueda
    const consultarPaquete = async (paquete) => {
        setBuscarPaquete(paquete)
        realizarConsultaDebounced(paquete) // Llamar al debounce
    }

    // Obtener tipos de proyecto 
    const obtenerTipoProyecto = async () => {
        const respuesta = await consumirApi('GET', `maestros/tipo-proyecto/${idEmpresa}`)
        setTiposProyectoDatos(respuesta.data)
        setMostrarModal(true)
    }

    // Agrega una nuevo paquete
    const registrarPaquete = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/paquete`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Paquete registrado correctamente" })
            limpiarCampos()
            obtenerPaquetes()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Abre el modal para registrar una nueva seccion asociada a una paquete
    const abrirModalSeccion = (e, idPaquete) => {
        e.stopPropagation() // Detiene la propagación del evento
        setIdPaquete(idPaquete)
        setMostrarModalSeccion(true)
    }

    // Crear la función debounced utilizando useCallback
    const realizarConsultaDebouncedSecciones = useCallback(
        debounce(async (seccion) => {
            if (seccion.trim() === "") {
                setSecciones([])
            } else {
                // Reemplazar el / con un +
                const seccionBusqueda = seccion.trim().replace(/\//g, '+')
                const respuesta = await consumirApi('GET', `maestros/seccion/buscar/${idEmpresa}/${seccionBusqueda}`)
                setSecciones(respuesta.success ? respuesta.data : respuesta.error)
            }
        }, 300), [] // Solo se crea una vez
    )

    // Consulta las secciones disponibles según el texto de búsqueda / dentro de registro de seccion dentro de una seccion
    const consultarSecciones = async (seccion) => {
        realizarConsultaDebouncedSecciones(seccion)
    }

    // Maneja la búsqueda de secciones según el texto ingresado / va mostrando resultados segun texto ingresado
    const manejarBusquedaSeccion = (seccion) => {
        setSeccion(seccion)
        consultarSecciones(seccion)
    }

    // Selecciona una acción del listado de sugerencias y carga el id de la seccion y de la seccion seleccionada
    const manejarSeleccionSeccion = (seccion) => {
        setSeccion(seccion.seccion)
        setIdSeccion(seccion.id)
    }

    // Agrega una nueva seccion al paquete seleccionado
    const registrarSeccion = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const respuesta = await consumirApi('POST', `maestros/paquete-detalle`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Sección registrada correctamente" })
            setMostrarModalSeccion(false)
            limpiarCampos()
            consultarPaquete(buscarPaquete)
        } else {
            setError(respuesta.error)
        }
    }

    // funcion para abrir el modal para editar ubicacion
    const abrirModalEditarPaquete = (data) => {
        data.e.stopPropagation()
        setIdPaquete(data.id)
        setPaquete(data.titulo)
        setDescripcion(data.descripcion)
        setMostrarModalEditar(true)
    }

    // Edición ubicación
    const enviarEdicionPaquete = async (e) => {
        e.preventDefault()
        const data = { paquete, descripcion }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/paquete/${idPaquete}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Paquete actualizado correctamente" })
            limpiarCampos()
            consultarPaquete(buscarPaquete)
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // funcion para abrir el modal para editar accion
    const abrirModalEliminarPaquete =(e, id) => {
        e.stopPropagation() // Detiene la propagación del evento
        setSelectedId((prevSelectedId) => (prevSelectedId === id ? null : id))
        setMostrarModalEliminar(true)
    }
    // funcion para abrir el modal para editar accion
    const eliminarPaquete = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/paquete/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Paquete eliminada correctamente" })
            limpiarCampos()
            consultarPaquete(buscarPaquete)
        } else {
            setError(respuesta.error)
        }
    }

    // obtiene el id del detalle de la seccion y abre el modal de confirmación para eliminar una acción
    const abrirModalEliminar = (id) => {
        setIdPaqueteDetalle(id)
        setMostrarModalConfirmacion(true)
    }

    // Elimina una acción seleccionada
    const eliminarSeccion = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/paquete-detalle/${idPaqueteDetalle}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Sección eliminada correctamente" })
            setMostrarModalConfirmacion(false)
            consultarPaquete(buscarPaquete)
        } else {
            setError(respuesta.error)
            setMostrarModalConfirmacion(false)
        }
    }

    // Reinicia los campos de los formularios y los estados relacionados
    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEliminar(false)
        setMostrarModalEditar(false)
        setMostrarModalSeccion(false)
        setSelectedId(null)
        setPaquete('')
        setDescripcion('')
        setError('')
        setSecciones('')
        setSeccion('')
        setIdSeccion('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    // Limpiar debounce cuando el componente se desmonte
    useEffect(() => {
        return () => {
            realizarConsultaDebounced.cancel() // Cancela el debounce en el desmontaje
        }
    }, [realizarConsultaDebounced])

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <div className="flex items-center gap-4 mt-2 bg-white">
                <Button className="ml-4" texto='+ Nueva Paquete' onClick={obtenerTipoProyecto} />
                <Input name="buscar_paquete" value={buscarPaquete} onChange={consultarPaquete} />
            </div>

            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5 mt-2"> No se encontraron Paquetes</div>
                ) : (
                    <div className="max-h-screen overflow-y-auto">
                        <ListaExpandible
                            nombre="secciones"
                            campoPrincipal="paquete"
                            campoDetalle="seccion"
                            data={datos}
                            registrar={abrirModalSeccion}
                            eliminar={abrirModalEliminar}
                            eliminarPadre={abrirModalEliminarPaquete}
                            editarPadre={abrirModalEditarPaquete}
                        />
                    </div>
                )
            )}

            {/* Modal para registrar una nuevo paquete */}
            <Modal isOpen={mostrarModal} title="Registrar nuevo paquete" onClose={limpiarCampos}>
                <Form onSubmit={registrarPaquete} isSubmitting={isSubmitting}>
                    <Input name="paquete" value={paquete} label="Nombre del paquete" onChange={setPaquete} />
                    <Input name="tipo_proyecto_id" value={idTipoProyecto} label="Tipo de proyecto" type="select" onChange={setIdTipoProyecto}
                        options={tiposProyectoDatos.map((tipo) => ({
                            value: tipo.id,
                            label: tipo.tipo_proyecto,
                        }))
                        }
                    />
                    <Input name="descripcion" type="textarea" value={descripcion} label="Descripción" onChange={setDescripcion} />
                    {error && (<ErrorAlert message={error} />)}
                </Form>
            </Modal>

            {/* Modal para registrar una nueva seccion */}
            <Modal isOpen={mostrarModalSeccion} title="Registrar nueva sección" onClose={limpiarCampos}>
                <Form onSubmit={registrarSeccion}>
                    {/* Input oculto para el ID de la sección */}
                    <Input show="hidden" name="paquete_id" value={idPaquete} onChange={setIdPaquete} />
                    {/* Input oculto para el ID de la seccion */}
                    <Input show="hidden" name="seccion_id" value={idSeccion} onChange={setIdSeccion} />
                    {/* Input para el nombre de la seccion */}
                    <Input name="seccion" value={seccion} label="Nombre de la sección" onChange={manejarBusquedaSeccion} />
                    <DesplegableDinamico
                        label="Seleccionar Sección"
                        opciones={secciones}
                        campo="seccion"
                        onSeleccionar={manejarSeleccionSeccion}
                    />
                    {error && (<ErrorAlert message={error} />)}
                </Form>
            </Modal>

            {/* Modal para registrar una nuevo paquete */}
            <Modal isOpen={mostrarModalEditar} title="Actualizar paquete" onClose={limpiarCampos}>
                <Form onSubmit={enviarEdicionPaquete} type="update" isSubmitting={isSubmitting} texto='Actualizar'>
                    <Input name="paquete" value={paquete} label="Nombre del paquete" onChange={setPaquete} />
                    <Input name="descripcion" type="textarea" value={descripcion} label="Descripción" onChange={setDescripcion} />
                    {error && (<ErrorAlert message={error} />)}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un paquete*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarPaquete}
                mensaje="¿Estás seguro de que deseas eliminar el paquete?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
            {/* Modal de confirmación para eliminar sección */}
            <ModalConfirmacion
                isOpen={mostrarModalConfirmacion}
                onClose={() => setMostrarModalConfirmacion(false)}
                onConfirm={eliminarSeccion}
                mensaje="¿Está seguro de que desea eliminar esta sección?"
            />
        </div>
    )
}

export default Paquetes
